import React, {Component} from 'react';

import AgencySubscriptionContent from "./AgencySubscriptionContent";
import {withRouterParams} from "../../utils/withRouterParams";

class AgencySubscription extends Component {
    render() {
        return (
            <AgencySubscriptionContent agencyId={this.props.match.params.id}/>
        )
    }
}

export default withRouterParams(AgencySubscription);

